(() => {
  if (window.zoReveal) return;
  window.zoReveal = true;
  const run = () => {
    const els = document.querySelectorAll('.zo-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) return els.forEach((el) => el.classList.add('is-in'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

(() => {
  if (window.zoAdd) return;
  window.zoAdd = true;
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.zo-add');
    const drawer = document.querySelector('cart-drawer');
    if (!form || !drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) return form.submit();
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch {
      form.submit();
    } finally {
      btn.disabled = false;
    }
  });
})();

(() => {
  if (window.zoLocator) return;
  window.zoLocator = true;
  window.addEventListener('message', (e) => {
    const h = e.data && e.data.zoLocatorHeight;
    if (!h) return;
    document.querySelectorAll('[data-zo-locator]').forEach((f) => {
      if (f.contentWindow === e.source) f.style.height = `${Math.ceil(h)}px`;
    });
  });
})();

(() => {
  if (window.zoQuiz) return;
  window.zoQuiz = true;
  document.addEventListener('click', (e) => {
    const quiz = e.target.closest('[data-zo-quiz]');
    if (!quiz) return;
    const opt = e.target.closest('[data-zo-quiz-goto]');
    const back = e.target.closest('[data-zo-quiz-back]');
    const restart = e.target.closest('[data-zo-quiz-restart]');
    if (!opt && !back && !restart) return;
    quiz.zoTrail = quiz.zoTrail || [quiz.querySelector('[data-zo-quiz-step]').dataset.zoQuizStep];
    if (opt) quiz.zoTrail.push(opt.dataset.zoQuizGoto);
    if (back) quiz.zoTrail.pop();
    if (restart) quiz.zoTrail.length = 1;
    const key = quiz.zoTrail[quiz.zoTrail.length - 1];
    quiz.querySelectorAll('[data-zo-quiz-step]').forEach((s) => { s.hidden = s.dataset.zoQuizStep !== key; });
    const done = key.startsWith('result-');
    quiz.querySelector('[data-zo-quiz-bar]').style.width = done ? '100%' : `${Math.min(quiz.zoTrail.length, 2) * 33}%`;
    quiz.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
})();

(() => {
  if (window.zoFaq) return;
  window.zoFaq = true;
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-zo-faq-search]');
    if (!input) return;
    const root = input.closest('.zo-faq');
    const q = input.value.trim().toLowerCase();
    let shown = 0;
    root.querySelectorAll('.zo-faq__group').forEach((g) => {
      let any = false;
      g.querySelectorAll('.zo-faq__item').forEach((item) => {
        const hit = !q || item.textContent.toLowerCase().includes(q);
        item.hidden = !hit;
        if (hit) { any = true; shown += 1; }
      });
      g.hidden = !any;
    });
    root.querySelector('[data-zo-faq-none]').hidden = shown > 0;
  });
})();
